import { EyeIcon, XIcon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

import { useShadowTarget } from '@splitfiesta/core';
import { useTranslation } from '@splitfiesta/i18n';

import { useShadowMode } from '@/hooks/useShadowMode';

export function ShadowModeBanner() {
  const { t } = useTranslation('admin');
  const { isActive, exitShadowMode } = useShadowMode();
  const targetUser = useShadowTarget();
  const navigate = useNavigate();

  if (!isActive || !targetUser) return null;

  const handleExit = async () => {
    await exitShadowMode();
    navigate('/');
  };

  return (
    <div
      className="bg-red-600 text-white px-4 py-2 text-center text-sm font-medium flex items-center justify-center gap-3 z-50"
      data-testid="shadow-mode-banner"
    >
      <EyeIcon className="w-4 h-4 shrink-0" />
      <span>
        {t('shadow.banner')} |{' '}
        {t('shadow.viewingAs', {
          name: targetUser.name,
          email: targetUser.email,
        })}{' '}
        | {t('shadow.readOnly')}
      </span>
      <button
        onClick={handleExit}
        className="ml-2 inline-flex items-center gap-1 bg-white/20 hover:bg-white/30 rounded px-2 py-0.5 text-xs font-semibold transition-colors"
        data-testid="shadow-mode-exit-btn"
      >
        <XIcon className="w-3 h-3" />
        {t('shadow.exit')}
      </button>
    </div>
  );
}
